<template>
  <base-card>
    <product-image
      v-if="!externalEditMode"
      @setImage="setImage"
      :image="targetItem.image"
      class="two"
    />
    <base-input
      :label="
        targetItem.type === 'category'
          ? StringLanguage.categoryName
          : StringLanguage.productName
      "
      v-model="targetItem.name"
      :valid="isValidField('main', 'name')"
      class="mb_15"
    />
    <div v-if="!externalEditMode" class="mb_15">
      <base-textarea
        :label="`${StringLanguage.ingredients} / ${StringLanguage.description}`"
        v-model="targetItem.description"
        :rows="isMobile ? 10 : 5"
      />
    </div>
    <div
      v-if="!externalEditMode"
      class="price-container"
      :class="{ mb_15: targetItem.type !== 'drink' }"
    >
      <base-input
        v-if="targetItem.sizes.length === 1 && targetItem.type !== 'drink'"
        :label="StringLanguage.value"
        v-model="targetItem.sizes[0].price"
        class="m_0 pr-7 flex"
        :money-mask="StringLanguage.currencyConfigs"
      />
      <base-input
        v-if="targetItem.sizes.length === 1 && hasPromo"
        :label="StringLanguage.promo"
        v-model="targetItem.sizes[0].originalPrice"
        class="pl-7 flex mb_0 ml_15"
        :money-mask="StringLanguage.currencyConfigs"
      />
    </div>

    <base-card
      v-if="
        externalEditMode &&
        targetItem.mode === 'pizza' &&
        targetItem.sizes.length === 1
      "
      class="mt_30"
    >
      <base-question text="Informe o máximo de sabores:" class="mb_20" />

      <base-input
        label="Max. sabores"
        v-model="targetItem.sizes[0].max"
        :type="'number'"
        class="size-item mb_0 pt_0"
      />
    </base-card>

    <div v-if="targetItem.type === 'drink'">
      <base-select
        title="Tipo de bebida"
        v-model="targetItem.group"
        :valid="isValidField('main', 'group')"
        class="mt_0"
      >
        <option
          v-for="(drinkGroup, i) in availableDrinkGroups"
          :key="`drink-group-${i}`"
          :value="drinkGroup"
        >
          {{ DrinkGroupName[drinkGroup] }}
        </option>
      </base-select>
    </div>

    <base-checkbox
      v-if="
        !externalEditMode &&
        targetItem.sizes.length === 1 &&
        targetItem.type !== 'drink'
      "
      v-model="hasPromo"
      :checked="hasPromo"
    >
      <p class="checkbox-area">Este produto está em promoção</p>
    </base-checkbox>
  </base-card>
</template>

<script>
// components
import { DrinkGroup, DrinkGroupName } from 'easyjs/lib/Schema/Components/Drink';
import { mapState } from 'vuex';
import BaseCard from '@/components/Card';
import ProductImage from '@/containers/Catalog/ProductImage';
import BaseInput from '@/components/Input';
import BaseTextarea from '@/components/Textarea';
import BaseCheckbox from '@/components/Checkbox';
import BaseSelect from '@/components/Select';
// libs

export default {
  components: {
    BaseCard,
    ProductImage,
    BaseInput,
    BaseTextarea,
    BaseCheckbox,
    BaseSelect,
  },
  data() {
    return {
      errors: {
        main: [],
      },
      hasPromo: false,
      DrinkGroupName,
      availableDrinkGroups: [
        DrinkGroup.AGUA,
        DrinkGroup.CACHACA,
        DrinkGroup.CAFE,
        DrinkGroup.CERVEJA,
        DrinkGroup.CHA,
        DrinkGroup.CONHAQUE,
        DrinkGroup.ENERGETICO,
        DrinkGroup.ESPUMANTE,
        DrinkGroup.GIM,
        DrinkGroup.ISOTONICO,
        DrinkGroup.LACTEA,
        DrinkGroup.LICOR,
        DrinkGroup.MILK_SHAKE,
        DrinkGroup.REFRIGERANTE,
        DrinkGroup.RUM,
        DrinkGroup.SAQUE,
        DrinkGroup.SUCO,
        DrinkGroup.TEQUILA,
        DrinkGroup.VINHO,
        DrinkGroup.VITAMINA,
        DrinkGroup.VODKA,
        DrinkGroup.WHISKY,
        DrinkGroup.OUTROS,
      ],
    };
  },
  props: {
    targetItem: { default: {} },
    externalEditMode: { default: false },
  },
  mounted() {
    if (this.targetItem.sizes.length) {
      this.hasPromo = parseFloat(this.targetItem.sizes[0].originalPrice) > 0;
    }
  },
  updated() {
    if (parseFloat(this.targetItem.sizes[0].price) === 0) this.hasPromo = false;
  },
  methods: {
    setImage(fileName) {
      this.targetItem.image = fileName;
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    highlightErrorFields() {
      this.errors = { main: [] };

      if (!this.targetItem.name) {
        this.errors.main = [...(this.errors.main || []), 'name'];
      }

      if (this.targetItem.type === 'drink') {
        if (!this.targetItem.group) {
          this.errors.main = [...(this.errors.main || []), 'group'];
        }
      }
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  watch: {
    hasPromo(newValue) {
      if (newValue === false) {
        this.targetItem.sizes[0].originalPrice = 0;
      }
    },
  },
};
</script>

<style scoped>
.price-container {
  display: flex;
  align-items: center;
}
.checkbox-area {
  color: #999999;
  font-size: 12px;
}
</style>
